import React, { Component } from "react";
import { Paper } from "@material-ui/core";
import { NEW_TRANSACTION_URL } from ".";
import { saveTransactionDetails } from "../../../store/actions";
import { connect } from "react-redux";
import Image from "../../Image";
class TransactionTypeCards extends Component {
  constructor() {
    super();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  getUrlByName = (name) => {
    let url = `/`;
    switch (name) {
      case "SIP":
        url = NEW_TRANSACTION_URL + "/sip/digital/transact";
        break;
      // case "ISIP":
      //   url = NEW_TRANSACTION_URL + "/sip/digital/modes/transact";
      //   break;
      case "STP":
        url = NEW_TRANSACTION_URL + "/stp/digital/transact";
        break;
      case "Switch":
        url = NEW_TRANSACTION_URL + "/switch/digital/transact";
        break;
      case "Redemption":
        url = NEW_TRANSACTION_URL + "/redemption/digital/transact";
        break;
      case "SWP":
        url = NEW_TRANSACTION_URL + "/swp/digital/transact";
        break;
      case "NFO & New Purchase":
        url = NEW_TRANSACTION_URL + "/nfo-new-purchase/digital/transact";
        break;
      case "NFO & Additional Purchase":
        url = NEW_TRANSACTION_URL + "/additional-purchase/digital/transact";
        break;
      case "Pause/Cancellation":
        url = NEW_TRANSACTION_URL + "/sip-cancellation/digital/transact";
        break;
      case "NCT":
        url = NEW_TRANSACTION_URL + "/nct-type/digital/transact";
        break;
      case "eNACH":
        url = NEW_TRANSACTION_URL + "/eNACH/digital/transact";
        break;
      default:
        break;
    }
    return url;
  };
  //Removing Stored Details Before Navigating to Transaction Pages
  goSip = () => {
    let pan =
      !!this.props.pan &&
      (this.props.name === "SIP" ||
        this.props.name === "ISIP" ||
        this.props.name === "Lumpsum" ||
        this.props.name === "eNACH")
        ? this.props.pan
        : "";
    let mode = this.props.name === "ISIP" ? "ISIP" : "";
    if (!!pan && this.props.name === "SIP") {
      this.props.saveTransactionDetails({});
      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/sip/digital/transact",
        state: {
          pan: pan,
          mode: "ISIP",
        },
      });
    } else {
      this.props.saveTransactionDetails({});
      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/sip/digital/modes",
        state: {
          pan: pan,
          mode: mode,
        },
      });
    }
  };

  Enach = () => {
    let pan =
      !!this.props.pan && this.props.name === "Enach" ? this.props.pan : "";
    this.props.saveTransactionDetails({});
    this.props.history.push({
      pathname: NEW_TRANSACTION_URL + "/sip/digital/modes/enach-folios",
      state: {
        pan: pan,
        mode: "Enach",
      },
    });
  };
  render() {
    return (
      <Paper
        className="transaction-type-cards-paper"
        style={{
          boxShadow: "-1px 1px 3px 1px lavender",
          padding: "15px 0px 0px 0px",
          borderRadius: 8,
        }}
        // onClick={this.props.onClick}
        onClick={
          () => {
            this.props.saveTransactionDetails({});
            this.props.history.push({
              pathname: this.getUrlByName(this.props.name),
              state: {
                pan:
                  !!this.props.pan &&
                  (this.props.name === "SIP" ||
                    this.props.name === "ISIP" ||
                    this.props.name === "Lumpsum" ||
                    this.props.name === "eNACH")
                    ? this.props.pan
                    : "",              },
            });
          }
        }
      >
        <div className="transact-whole-card">
          <div className="otp">
            <Image
              src={`${this.props.image}`}
              className="transact-whole-card-image"
              // style={{ height: 80 }}
              alt={this.props.name}
            />
          </div>
          <div className="transaction-type-cards-name">{this.props.name}</div>
        </div>
        {/* {this.props.name !== "Pause/Cancellation" &&
        this.props.name != "NCT" &&
        this.props.name != "eNACH" ? (
          <div
            style={{
              display: "flex",
              boxShadow: "1px -2px 2px -1px #EEEEEE",
            }}
          >
            <div
              className="transaction-type-card-modes"
              onClick={() =>
                this.props.history.push({
                  pathname: this.getUrlByName(this.props.name),
                  state: {
                    pan:
                      !!this.props.pan &&
                      (this.props.name === "SIP" ||
                        this.props.name === "Lumpsum")
                        ? this.props.pan
                        : "",
                  },
                })
              }
            >
                 Digital Mode
                 <Image
                src={`${"/images/mode_arrow.svg"}`}
                style={{ height: 12,marginTop:3,marginLeft:10 }}
                />
            </div>
            {this.props.name === "STP" || this.props.name === "SWP" ? (
              ""
            ) : (
              <div
                className="transaction-type-card-modes"
                onClick={() =>
                  this.props.history.push({
                    pathname: this.props.navigationProps.physical,
                    state: {
                      type: this.props.navigationProps.type,
                      flag: this.props.navigationProps.flag,
                      pan:
                        (!!this.props.pan &&
                          this.props.name === "Lumpsum") ||
                        this.props.name === "SIP"
                          ? this.props.pan
                          : "",
                    },
                  })
                }
              >
                Phygital Mode
                <Image
                src={`${"/images/mode_arrow.svg"}`}
                style={{ height: 12,marginTop:3,marginLeft:10 }}
                />
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              boxShadow: "1px -2px 2px -1px #EEEEEE",
            }}
          >
            <div
              className="transaction-type-card-modes"
              onClick={() =>
                this.props.history.push({
                  pathname: this.getUrlByName(this.props.name),
                })
              }
            >
            Proceed
            <Image
                src={`${"/images/mode_arrow.svg"}`}
              style={{ height: 12,marginTop:3,marginLeft:10 }}
            />
            </div>
          </div>
        )} */}
      </Paper>
    );
  }
}
//Removing Stored Details Before Navigating to Transaction Pages
export default connect(null, { saveTransactionDetails })(TransactionTypeCards);
